
import { css } from 'lit';
export default css`
/* Note: this are the styles from component_tweaks.css:16 */

.video--vimeo {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  margin-bottom: 50px;
}

.video--vimeo iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
`;